import * as React from 'react';
import { useSelector } from 'react-redux';

import { Layout, LayoutBlock, Main, MainContent } from '../../../components/redesign/Page';
import { PageLoader } from '../../../components/redesign/PageLoader';
import { selectLoading } from '../../../selectors/appStatus';
import { BankListContainer } from '../../BankList';
import { CategoriesContainer } from '../../CategoriesContainer';
import { FreshPromoListContainer } from '../../FreshPromoList';
import { LowRateMortgagePromosContainer } from '../../LowRateMortgagePromosContainer';
import { MortgageContainer } from '../../MortgageContainer';
import { PromoCompilationsContainer } from '../../PromoCompilation';
import { HeadCategoriesContainer } from '../../redesign/HeadCategoriesContainer';
import { MortgageProgramsContainer } from '../MortgageProgramsContainer';
import { PageHeaderContainer } from '../PageHeaderContainer';

export const PageContainer: React.FC = () => {
  const isLoading = useSelector(selectLoading);

  return (
    <Main>
      <Layout>
        <PageHeaderContainer />
      </Layout>
      <MainContent>
        <LayoutBlock>
          <HeadCategoriesContainer />
        </LayoutBlock>
        <LayoutBlock>
          <PromoCompilationsContainer />
        </LayoutBlock>
        <LayoutBlock>
          <FreshPromoListContainer />
        </LayoutBlock>
        <LayoutBlock>
          <LowRateMortgagePromosContainer />
        </LayoutBlock>
        <LayoutBlock>
          <BankListContainer />
        </LayoutBlock>
        <LayoutBlock>
          <MortgageProgramsContainer />
        </LayoutBlock>
        <LayoutBlock>
          <MortgageContainer />
        </LayoutBlock>
        <LayoutBlock>
          <CategoriesContainer />
        </LayoutBlock>
      </MainContent>
      {isLoading && <PageLoader />}
    </Main>
  );
};
